import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {Grupo} from '../../../../types/ObraDetails';
import styles from './dataGroup.module.scss';
import TitleValue from '../../components/titleValue/titleValue';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DataGroupProps {
  group: Grupo;
  index: number;
}

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const DataGroup: FC<DataGroupProps> = (props) => {
  const { group, index, } = props;
  const [t] = useTranslation();

  const getFormattedBudget = (value?: string | number | null) => {
    if (value) {
      let floatValue = parseFloat(String(value));
      if (!isNaN(floatValue)) {
        floatValue = Math.round(floatValue * 100) / 100;
        const parts = floatValue.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if (parts.length == 2) {
          return parts[0] + ',' + parts[1].padEnd(2, '0');
        } else {
          return parts[0];
        }
      }
    }
    return null;
  };

  const initialBudget = getFormattedBudget(group.importeEstimado);
  const updatedBudget = getFormattedBudget(group.importeActualizado);
  const finalCertifiedBudget = getFormattedBudget(group.importeFinal);

  return (
    <tr key={index} className={styles.containerGroup}>
      <td>
        <div className={styles.titleValue1}>
          <TitleValue
            identifier={`group-${index}`}
            title={t('details.classification.group') || ''}
            value={group.grupo?.codigo ? `${group.grupo.codigo} ${group.grupo.nombre}` : ''}
            onlyView={true}
          />
        </div>
      </td>
      <td>
        <div className={styles.titleValue2}>
          <TitleValue
            identifier={`subgroup-${index}`}
            title={t('details.classification.subGroup') || ''}
            value={group.subGrupo?.codigo ? `${group.subGrupo.codigo} ${group.subGrupo.nombre}` : ''}
            onlyView={true}
          />
        </div>
      </td>
      <td>
        <div className={styles.titleValue3}>
          <TitleValue
            identifier={`data-estimated-budget-${index}`}
            title={t('details.classification.estimatedBudget')}
            value={initialBudget ?? t('details.noData')}
            isDecimalNumber={!!initialBudget}
            onlyView={true}
          />
        </div>
      </td>
      <td>
        <div className={styles.titleValue3}>
          <TitleValue
            identifier={`data-updated-budget-${index}`}
            title={t('details.classification.updatedBudget')}
            value={updatedBudget ?? t('details.noData')}
            isDecimalNumber={!!updatedBudget}
            onlyView={true}
          />
        </div>
      </td>
      <td>
        <div className={styles.titleValue3}>
          <TitleValue
            identifier={`data-final-budget-${index}`}
            title={t('details.classification.finalBudget')}
            value={finalCertifiedBudget ?? t('details.noData')}
            isDecimalNumber={!!finalCertifiedBudget}
            onlyView={true}
          />
        </div>
      </td>
    </tr>
  );
};

export default DataGroup;
